// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-checkout[data-v-02b40019]{background-color:#fff;border-top:1px solid #c1c1c1;padding:1em 0}.floating-checkout__inner[data-v-02b40019]{display:flex;align-items:center;gap:1em;margin:0 auto;max-width:500px}.floating-checkout__price[data-v-02b40019]{display:flex;flex-direction:column;align-items:flex-start;white-space:nowrap}.floating-checkout__price .gp-price--small-yen[data-v-02b40019]{font-size:16px;font-weight:700}", ""]);
// Exports
module.exports = exports;
